import { CommonUtility } from '@utility/common';

const checkQueryInText = (text?: string, query?: string) => {
  if (!CommonUtility.isString(query) || !CommonUtility.isString(text)) {
    return false;
  }

  const textLower = text?.toLowerCase?.();
  const queryLower = query?.toLowerCase?.();
  if (queryLower && textLower?.includes?.(queryLower)) {
    return true;
  }
  if (textLower && queryLower?.includes?.(textLower)) {
    return true;
  }
  return false;
};

interface IDynamicOption {
  value: string;
  text: string;
  searchTags: string[];
  imageUrl: string;
}

export const dynamicSearchFunction = (
  options?: IDynamicOption[],
  query?: string,
) => {
  return options?.filter(option => {
    const searches = [option.text];
    if (CommonUtility.isValidArray(option.searchTags)) {
      searches.push(...option.searchTags);
    }
    return searches.some(text => checkQueryInText(text, query));
  });
};

export function parseDynamicOptions(options?: IDynamicOption[]) {
  return options?.map(option => ({
    ...option,
    image: option.imageUrl,
  }));
}
